module.exports = __webpack_public_path__ + "static/img/finger.5112fc37.gif";